<template>
    <b-tab :title="$store.state.localization.data.mainPage.limitsLabel">
        <div class="row">
            <div class="col-12">
                <b-table
                    class="textMiddle"
                    small
                    hover
                    bordered
                    show-empty
                    responsive
                    head-variant="light"
                    selectable
                    select-mode="single"
                    :items="limits"
                    :fields="headers"
                    v-bind:emptyText="$store.state.localization.data.common.table.noData"
                    :foot-clone="false"
                    >
                    <template v-slot:empty="scope">
                        <div class="row justify-content-md-center">
                        <h5>{{ scope.emptyText }}</h5>
                        </div>
                    </template>
                </b-table>
            </div>
            </div>
      </b-tab>
  </template>
  
  <script>
  
  export default {
    name: "LimitsTab",
    props: {
      driver: Object
    },
    data() {
      return {
        limits: []
      };
    },
    computed: {
      headers() {
            const headers = [];

            for (let key in this.$store.state.localization.data.mainPage.drivers.limits) {
                headers.push({
                    key: key,
                    label: this.$store.state.localization.data.mainPage.drivers.limits[key],
                    sortable: true,
                    thClass: "textMiddle",
                });
            }

            return headers;
        },
    },
    created() {
        for (let i = 0; i < this.driver.limits.length; i++) {
            const fuelType = this.$store.state.localization.data.common.fuelTypeCodeOptions.find(x => x.key == this.driver.limits[i].fuelTypeCode);
            const limitType = this.$store.state.localization.data.mainPage.limits.limitTypeOptions.find(x => x.key == this.driver.limits[i].limitType);
            
            let currentValue = 0;
            for (let j = 0; j < this.driver.limits[i].limitCharges.length; j++) {
                currentValue += this.driver.limits[i].limitCharges[j].value;
            }

            this.limits.push({
                fuelTypeCode: fuelType.value,
                limitType: limitType.value,
                limitValue: this.driver.limits[i].limitValue,
                currentValue: currentValue
            });
        }
    },
    methods: {
    },
  };
  </script>
  